<template>
  <div class="sand-box" >
    <Tool/>
    <NavBar/>
    <Statement />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Tool from './components/Tool.vue'
import Statement from './components/Statement.vue'
var vm=null
export default {
  name:'SandBox',
  components:{
    NavBar,
    Tool,
    Statement
  },
  created(){
    vm=this
  },
  data(){
    return{
      isCom: false

    }
  },
  methods:{

  },




  

}

  function init(){
      console.log('----------加载完成')
      
      vrLoadEndCallBack()
    }

    		// 小行星加载完成回调
		function vrLoadEndCallBack(){
      vm.isCom = true
			window.parent.vrLoadEndCallBack();
		}
</script>

<style lang="scss" scoped>


</style>